<template>
    <v-card outlined class="grafica-salidas">
        <div class="d-flex align-center flex-wrap px-4 pt-3">
            <span class="grafica-salidas__title">{{ title }}</span>
            <v-spacer></v-spacer>
            <v-btn-toggle v-if="toggle" v-model="chartType" mandatory dense color="primary" class="grafica-salidas__toggle">
                <v-btn small value="bar" aria-label="Barras"><i class="fas fa-chart-column" aria-hidden="true"></i></v-btn>
                <v-btn small value="line" aria-label="Líneas"><i class="fas fa-chart-line" aria-hidden="true"></i></v-btn>
            </v-btn-toggle>
        </div>
        <v-card-text>
            <ChartCanvas :type="chartType" :labels="labels" :datasets="datasets" :options="options" :loading="loading"
                :error="error" :aria-label="title" height="280px"></ChartCanvas>
        </v-card-text>
    </v-card>
</template>
<script>
import ChartCanvas from '@/components/shared/ChartCanvas.vue';

// Constante: ChartCanvas recrea la gráfica cuando `options` cambia, y un objeto nuevo por render lo haría siempre.
const OPTIONS = { tooltips: { mode: 'index', intersect: false } };

/** Tarjeta con una gráfica de piezas por día (un producto por serie) y selector barras/líneas. */
export default {
    name: 'GraficaSalidas',
    components: { ChartCanvas },
    props: {
        title: { type: String, required: true },
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        error: { type: String, default: '' },
        // Sin selector barras/líneas (p. ej. categorías como sucursales, donde una línea no dice nada).
        toggle: { type: Boolean, default: true },
        type: { type: String, default: 'bar' }
    },
    data() {
        return { chartType: this.type, options: OPTIONS };
    }
};
</script>
<style scoped>
/* Sin clases `text-*` de Vuetify: main.css les cambia la fuente. */
.grafica-salidas__title {
    font-size: 1rem;
    font-weight: 700;
}
.grafica-salidas__toggle {
    flex: 0 0 auto;
}
</style>
